import(/* webpackMode: "eager" */ "/app/src/app/knowledge-hub/info-page.module.scss");
import(/* webpackMode: "eager" */ "/app/src/components/knowledge-hub/InfoTabs.tsx")